"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$postForwardSettings = exports.$postForwardDelay = exports.$getForwardDelay = exports.$getAllForwardsSettings = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/sip-accounts';

/**
 *
 * @param {*} _sipAccount Sip account to fetch on
 * @param {*} trigger The trigger to filter on (busy, inconditional, unavailable)
 */
var $getAllForwardsSettings = (_sipAccount, trigger) => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'get',
  url: "".concat(base, "/").concat(_sipAccount, "/forwards"),
  params: {
    trigger
  }
});
exports.$getAllForwardsSettings = $getAllForwardsSettings;
var $postForwardSettings = (_sipAccount, settings) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_sipAccount, "/forwards"),
  body: settings
});
exports.$postForwardSettings = $postForwardSettings;
var $getForwardDelay = _sipAccount => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_sipAccount, "/forwards/delay")
});
exports.$getForwardDelay = $getForwardDelay;
var $postForwardDelay = (_sipAccount, delay) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_sipAccount, "/forwards/delay"),
  body: delay
});
exports.$postForwardDelay = $postForwardDelay;